import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The receiver's preview as labelled lines on the approval card (approvalCard.ts previewFields): the task, where it is,
 * the exact change, the whole comment or notes, the links, who can see it and who may be notified. A long value gets a
 * box that scrolls, read to the end before Confirm, as the action's own long values do (ActionDetails.tsx).
 */
export function PreviewFieldList({ fields }) {
    if (!fields.length)
        return null;
    return _jsx("dl", { className: "gyro-action-preview-fields", children: fields.map((field, index) => _jsxs("div", { className: "gyro-action-preview-field", children: [_jsx("dt", { children: field.label }), _jsx("dd", { className: field.long ? 'long' : undefined, children: field.value })] }, `${field.label}-${index}`)) });
}
//# sourceMappingURL=PreviewFieldList.js.map